import React from "react";

import { Box, Theme, Typography, useTheme } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import useDialogState from "@/hooks/useDialogState";
import AddWeightButton from "@/pages/Clients/Buttons/AddWeightButton";
import EditIconButton from "@/pages/Clients/IconButtons/EditIconButton";
import { colors } from "@/theme/overrides/colors";

import AddCurrentWeightModal from "./AddCurrentWeightModal";
import DeleteWeight from "./DeleteWeightModal";
import EditCurrentWeightModal from "./EditCurrentWeightModal";
import ScaleIcon from "../../../../../../components/Icons/ScaleIcon";

const useStyles = makeStyles()((theme: Theme) => ({
  currentWeight: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    background: colors.light,
    padding: theme.spacing(1),
  },
}));

interface Props {
  currentWeightId: string;
  currentWeight: number;
  weightDate: Date;
  onDelete: () => void;
}

const CurrentWeight: React.FC<Props> = ({
  currentWeight,
  weightDate,
  currentWeightId,
  onDelete,
}) => {
  const { classes } = useStyles();
  const theme = useTheme();
  const addCurrentWeightDialog = useDialogState();
  const editCurrentWeightDialog = useDialogState();
  return (
    <>
      <div className={classes.currentWeight}>
        <Box display="flex" alignItems="center">
          <ScaleIcon fontSize="large" />
          <Box marginRight={theme.spacing(0.5)} />
          <Typography variant="body1" fontWeight="bold">
            Current Weight
          </Typography>
        </Box>
        <Box>
          {currentWeight ? (
            <Box display="flex" alignItems="center">
              <Typography variant="h6" fontWeight="bold">
                {currentWeight} kg
              </Typography>
              <EditIconButton onClick={() => editCurrentWeightDialog.show()} />
              <DeleteWeight
                onDelete={onDelete}
                title="Delete current weight"
                message="Do you really want to delete current weight?"
              />
            </Box>
          ) : (
            <AddWeightButton onClick={() => addCurrentWeightDialog.show()} />
          )}
        </Box>
      </div>

      <AddCurrentWeightModal
        visibility={addCurrentWeightDialog.shown}
        onClose={() => addCurrentWeightDialog.hide()}
      />

      <EditCurrentWeightModal
        visibility={editCurrentWeightDialog.shown}
        onClose={() => editCurrentWeightDialog.hide()}
        weight={currentWeight}
        weightDate={weightDate}
        currentWeightId={currentWeightId}
      />
    </>
  );
};

export default CurrentWeight;
